<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';
import appConfig from "@/app.config";

import InvoiceService from '@/services/invoice'

moment.locale('pt-BR');

export default {
  page: {
    title: "Histórico de Metas",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, DatePicker },
  data() {
    return {
      title: "Histórico de Metas",
      loading: false,
      goals: [],
      searchParams: {
        periodDate: '',
      },
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      totalGoalValue: 0,
      totalInvoicesValue: 0,
      totalRemainingValue: 0,

      fields: [
        { key: 'sellerName', sortable: true, label: 'Vendedor' },
        { key: 'goalValue', sortable: true, label: 'R$ Valor Objetivo', formatter: (value) => {
          return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'invoicesValue', sortable: true, label: 'R$ Valor Realizado', formatter: (value) => {
          return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'remainingValue', sortable: true, label: 'R$ Valor Restante', formatter: (value) => {
          return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'participation', sortable: true, label: 'Participação', formatter: (value) => {
          return (value || 0).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%';
        } },
      ],
    };
  },
  mounted() {
    this.searchParams.periodDate = new Date();

    this.search();
  },
  methods: {
    search() {
      this.load();
    },
    load() {
      this.loading = true;

      InvoiceService.getGoals(this.searchParams.periodDate)
        .then(res => {
          this.loading = false;

          this.goals = res.data.goals;

          this.totalGoalValue = res.data.totalGoalValue;
          this.totalInvoicesValue = res.data.totalInvoicesValue;
          this.totalRemainingValue = res.data.totalRemainingValue;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.load(this.currentPage);
    },
    exportData() {
      this.loading = true;

      InvoiceService.exportGoals(this.searchParams.periodDate).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Metas.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group mb-3">
                        <label>Período</label>
                        <date-picker
                          v-model="searchParams.periodDate"
                          lang="pt-br"
                          type="month"
                          format="MMM/YYYY"
                        ></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="goals"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template slot="bottom-row">
                  <td class="text-left nowrap-col">
                    <strong>Valor Total:</strong>
                  </td>
                  <td class="text-left nowrap-col">
                    <h4 class="m-0">R$ {{totalGoalValue | currency}}</h4>
                  </td>
                  <td class="text-left nowrap-col">
                    <h4 class="m-0">R$ {{totalInvoicesValue | currency}}</h4>
                  </td>
                  <td class="text-left nowrap-col">
                    <h4 class="m-0">R$ {{totalRemainingValue | currency}}</h4>
                  </td>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <!-- <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </Layout>
</template>


<style lang="scss">
  .button-search {
    display: flex;
    align-items: center;
  }

  .mx-input:disabled {
    background-color: #e8e8e8 !important;
  }

  .nowrap-col {
    white-space: nowrap;
  }
</style>